///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-total-points')) {
      const totalPointsElement = document.querySelector('.js-total-points');

      // on addition of new fields calls keyupEvents and onClick functions
      eventsForNewFields(totalPointsElement);

      // On keyup Event, get input values and calculate running total
      keyupEvents(totalPointsElement);

      // On click Event(for arrows) or delete button, get input values and calculate running total
      onClickEvents(totalPointsElement);
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Computes the new total for current standard
  //               and returns value for dynamic calculator.
  //
  function calculateNewTotal(totalPointsElement) {
    const initialTTpointsTotal = Number(totalPointsElement.dataset.teachingToolTotalPoints),
          initialStandardPointsTotal = Number(totalPointsElement.dataset.standardTotalPoints);

    let newStandardTotal = 0;

    document.querySelectorAll('.js-indicator-points').forEach( (points) => {
      const bodyCard = points.closest('.card.js-nested-form-container.mb-1');

      if (!bodyCard.classList.contains('for-delete') && !isNaN(points.valueAsNumber)) {
        newStandardTotal += points.valueAsNumber;
      }
    });

    // The total can't be calculated at the top with the other values because
    // the newStandardTotal isn't available yet.
    // eslint-disable-next-line one-var
    const totalToShow = initialTTpointsTotal + (newStandardTotal- initialStandardPointsTotal);
    totalPointsElement.innerText = totalToShow;
  }

  ///////////////////////////////////////////////
  //
  // Description - Adds keyup events for calculating total to all js-indicator-points
  //               total to all js-indicator-points fields.
  //
  function keyupEvents(totalPointsElement) {
    document.querySelectorAll('.js-indicator-points').forEach(function(e) {
      e.addEventListener('keyup', function() {
        calculateNewTotal(totalPointsElement);
      });
    });
  }

  ///////////////////////////////////////////////
  //
  // Description - Adds click events for calculating total
  //               to all js-indicator-points, delte_record,
  //               and remove-record fields.
  //
  function onClickEvents(totalPointsElement) {
    const recalculatableClasses = '.js-indicator-points,.delete_record,.remove_record';

    document.querySelectorAll(recalculatableClasses).forEach(function(e) {
      e.addEventListener('click', function() {
        calculateNewTotal(totalPointsElement);
      });
    });
  }

  ///////////////////////////////////////////////
  //
  // Description - Adds click events for new fields created
  //               by other events, and adds them to
  //               querySelector to obtain proper events
  //               for all additional fields.
  //
  function eventsForNewFields(totalPointsElement) {
    document.querySelector('.add_fields').addEventListener('click', function() {
      keyupEvents(totalPointsElement);
      onClickEvents(totalPointsElement);
    });
  }
})();
